import { render } from "./CertificationModal.vue?vue&type=template&id=2aefcafb"
import script from "./CertificationModal.vue?vue&type=script&lang=js"
export * from "./CertificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__